export default {
  'required': 'Required',
  'last': 'At least one',
  'noData': 'No Data Found',

  'search': 'Search',
  'returnsApplication': 'Hot words',
  'clearCondition': 'Clear condition',
  'more': 'More',
  'singleChoice': 'Single choice',
  'multipleChoice': 'Multiple choice',
  'allLook': 'Public（All buyers）',
  'allLook2': 'for all buyers ( no more than 10 pics)',
  'onlyLook': 'Just buyers in Buyers Pool',
  'onlyLook2': 'for buyers in my client-list only',
  'onlyPreRegistered': 'Only pre-registered viewers are visible',
  'onlyPreRegistered2': 'for registered buyers only',
  'invitation': 'Send invitation',
  'Handbook': 'Help',
  'versionLog': 'Update log',
  'all': 'All',
  'toBeConfirmed': 'To be confirmed',
  'confirmedText': 'confirmed',
  'toBeConfirmedPerson': 'To be confirmed by employees',
  'productTipsContent':'Click "Invite" to get approval from exhibitors. The exhibitor will make decision according to your basic information.',
  'productTipsTitle':'Warning',
  'ok':'OK',
  'utilsTips': 'Note: 1、Please upload pictures (maximum 10) of only  one product  here.',
  'utilsTips2': '2、The first picture will be used as the cover picture of the exhibit and displayed on the exhibit list. Please upload the complete product picture',
  'success': 'Successful',
  'exhibitorResearch': 'Exhibitor Research'
}
